module.exports = __webpack_public_path__ + "img/shape-metal_ab-mobile@2x.84afb5f5.png";